import {ReasonsService} from "../../../../../common/api/dictionaries";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class BackofficeReasonsService extends ReasonsService {
    static readonly context = 'backoffice'
    constructor(http: HttpClient) {
        super(http, BackofficeReasonsService.context);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/backoffice.reasons.service.ts